// src/components/CodeEditor.js
import React from 'react';
import Editor from '@monaco-editor/react';

const CodeEditor = ({ code, onChange }) => {
  return (
    <div style={{ border: '1px solid #ccc', borderRadius: '4px' }}>
      <Editor
        height="50vh"
        defaultLanguage="javascript"
        defaultValue="// JavaScriptコードを書いてみましょう"
        value={code}
        onChange={onChange}
        theme="vs-dark"
        options={{
          minimap: { enabled: false },
          fontSize: 14,
        }}
      />
    </div>
  );
};

export default CodeEditor;  // この行が重要です